module.exports = __webpack_public_path__ + "static/img/demo-image-sq-01-01.7184a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo-image-sq-01-01.png
// module id = Fm7J
// module chunks = 1